












































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";

// Components
import BrandLogo from "@/components/app/global/brand/logo.vue";
import ProfileDropdown from "@/components/app/global/user/profileDropdown.vue";

// Mixins
import Context from "@/mixins/context";
import ClientMixin from "@/mixins/clientMixin";

// Types
import {
  IBasketProviderData,
  IBasketProviderMethods
} from "@/models/providers/baskets";

@Component({
  components: {
    BrandLogo,
    ProfileDropdown
  }
})
export default class BasketTopper extends Mixins(Context, ClientMixin) {
  // Inject
  @Inject({ from: "providerData" })
  public readonly $providerData!: () => IBasketProviderData;

  @Inject({ from: "providerMethods" })
  public readonly $providerMethods!: IBasketProviderMethods;

  // Provider
  public get basketData() {
    return this.$providerData();
  }

  public get basketMethods() {
    return this.$providerMethods;
  }

  public get client() {
    return this.$_.get(this.basketData, "client");
  }

  public get account() {
    return this.$_.get(this.basketData, "account");
  }

  public get basket() {
    return this.$_.get(this.basketData, "basket");
  }

  public get clientName() {
    return this.getClientName({
      client: this.client
    });
  }

  public get clientBasketsLink() {
    return {
      name: "adminClientBaskets",
      params: { clientId: this.$_.get(this.client, "id") }
    };
  }

  public get hasNonDefaultPricelist() {
    return (
      !this.$_.isEmpty(this.account) &&
      this.account.pricelist_id !== this.account.brand.pricelist_id
    );
  }
}
